import React, {createContext,useState,useContext,ReactNode,useEffect,} from "react";
import i18n from "../i18n.js";
interface LanguageContextType {
    language: string;
    toggleLanguage: (lang: string) => void;
    }

    const LanguageContext = createContext<LanguageContextType | undefined>(undefined);

    interface LanguageProviderProps {
    children: ReactNode;
    }

export const LanguageProvider: React.FC<LanguageProviderProps> = ({ children }) => {
    const [language, setLanguage] = useState(i18n.language || "en");

    const toggleLanguage = (lang: string) => {
    if (lang) {
    setLanguage(lang);
    }
    };

    useEffect(() => {
    if (i18n.language !== language) {
    i18n.changeLanguage(language);
    document.documentElement.lang = language;
    }
    }, [language]);

return (
<LanguageContext.Provider value={{ language, toggleLanguage }}>
    {children}
</LanguageContext.Provider>
);
};

export const useLanguage = () => {
    const context = useContext(LanguageContext);
    if (!context) {
    throw new Error("useLanguage must be used within a LanguageProvider");
    }
    return context;
    };
